import { Outlet } from 'react-router-dom';
import NavBar from "../navbar";
import {Box, styled} from "@mui/material";
import {scale} from "../../utils";

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  width: '100%',
  justifyContent: 'center',
  paddingTop: '80px',
  paddingBottom: '10px',
  alignItems: 'center',
  height: '85vh',
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    padding: 0,
    paddingTop: scale(90),
    height: '100%',
    borderBottom: `${scale(40)} solid ${theme.palette.primary.main}`,
    overflow: 'hidden',
    boxSizing: 'border-box'
  },
}));

const Layout = () => {
  return (
    <Box>
      <NavBar />
      <Wrapper>
        <Outlet />
      </Wrapper>
    </Box>
  );
};

export default Layout;
